import type { CardLogo } from './CardLogo';

export class Tag {
  name: string;
  icon: CardLogo | string;
  color: string;
  style: any;
}
